export default {
      id: "arrow_nav_left-usage",
      viewBox: "0 0 7 12",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow_nav_left",
      toString: function () {
        return this.url;
      }
    }